var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":function($event){return _vm.ActionSetAmount()}}},[_vm._v(" set amount ")])])}
var staticRenderFns = []

export { render, staticRenderFns }